module.exports = {
    // clientURL: 'http://localhost:3000',
    clientURL: 'https://fan-club-portal.netlify.app',
    // serverURL: 'http://localhost:5000'
    serverURL: 'https://fan-club-portal-server.herokuapp.com'
};